<div class="row">
  <div class="col-md-9 col-lg-10" id="visualization"></div>
  <div class="col-md-3 col-lg-2">
    <form>
      <div class="row">
        <div class="form-group col-xs-6 col-md-12">
          <label class="control-label">Start</label>
          <app-datetime
            name="startDate"
            [(ngModel)]="selectedItem.start"
            [options]="utilService.getDefaultDateOptions(false, false, true, false, true)"
            (dateChange)="timelineSelectedItem_dateChanged()"
            [utc]="true"
          ></app-datetime>
          <app-tooltip
            [form]="'system.entityGroupFeeScheduleTimeline'"
            [uid]="'start'"
          ></app-tooltip>
        </div>
        <div class="form-group col-xs-6 col-md-12">
          <label class="control-label">End</label>
          <app-datetime
            name="endDate"
            [(ngModel)]="selectedItem.end"
            [options]="utilService.getDefaultDateOptions(false, false, true, false, true)"
            (dateChange)="timelineSelectedItem_dateChanged()"
            [utc]="true"
          ></app-datetime>
          <app-tooltip [form]="'system.entityGroupFeeScheduleTimeline'" [uid]="'end'"></app-tooltip>
        </div>
      </div>
      <button
        class="btn btn-danger"
        [disabled]="!this.selectedItem.id"
        (click)="removeSelectedItem()"
      >
        Remove
      </button>
      <button
        class="btn btn-default"
        [disabled]="!this.selectedItem.id"
        (click)="showSelectedItemDetails()"
      >
        Details
      </button>
    </form>
  </div>
</div>
